import React from 'react';
import PropTypes from 'prop-types';

const GymnasticsPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M12.81 17.164c.174.353.348.73.543 1.134-.348.068-.726.11-1.096.11-3.224 0-5.875-2.765-5.875-5.99 0-2.748 2.039-5.34 4.809-5.832 0-.009 0 .008 0 0 0-.226-.391-.548.476-.659V3h.862v2.893c.867.11.769.315.816.705 0 0 0-.008 0 0 1.67.23 2.727 1.198 3.522 2.197a9.744 9.744 0 0 0-1.07.641 4.67 4.67 0 0 0-8.178 3.084 4.673 4.673 0 0 0 5.19 4.644zm14.767-.297c.9 0 1.423 1.091 1.423 1.988v3.25c0 .9-.527 1.695-1.423 1.695H26.17l1.406 5.2h-3.25l-1.41-5.2H9.482L8.077 29h-3.25l1.41-5.2h-1.41C3.93 23.8 3 23.001 3 22.105v-3.25c0-.897.93-1.988 1.827-1.988h2.336c1.041.866 1.266 1.733 2.405 1.733h-4.13c-.45 0-.705.608-.705 1.058v1.623c0 .45.255 1.652.706 1.652H26.56c.45 0 .706-1.202.706-1.652v-1.623c0-.45-.255-1.058-.706-1.058h-1.69c.34 0 .815-.867 1.006-1.733h1.7zM20.74 9.44c2.502.692 4.342 2.935 4.338 5.603 0 3.229-2.507 5.842-5.731 5.842-3.225 0-5.787-2.617-5.787-5.842 0-2.672 1.797-4.92 4.334-5.612-.004-.025.025-.051.025-.08 0-.243.68-.557.68-.774V3h1.733v5.527c.867.213.561.565.561.829 0 .03-.144.055-.153.085zm-5.255 6.487c.204.335.42.68.654.968a6.079 6.079 0 0 0 1.993-4.473c0-.361-.034-.718-.098-1.062a4.975 4.975 0 0 0-1.092.697c.017.152.026.31.026.467a4.673 4.673 0 0 1-1.483 3.403zm3.815 3.794a4.673 4.673 0 1 1 0-9.347 4.673 4.673 0 0 1 0 9.347z"
    />
  );
};

GymnasticsPath.propTypes = {
  fill: PropTypes.string,
};

export default GymnasticsPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/sports/gymnastics.jsx